export default __webpack_public_path__ + "static/media/icon-arrow-down.66bc08cf.svg";